import { Button, STATUS_TYPES, Notification, generateResolver, yup } from "dyl-components";
import { useDispatch, useSelector } from "react-redux";
import authActions from "actions/auth/auth";
import basePath from "actions/basePath";
import { useController, useForm } from "react-hook-form";
import { Form } from "semantic-ui-react";

const SimulateUserForm = ({ user_id, onClose }) => {
    const { control, handleSubmit, formState: { isValid, isDirty } } = useForm({
        mode: 'onChange',
        resolver: generateResolver({
            password: yup.string().required("Password is required"),
        }),
        defaultValues: {
            password: "",
        },
    });
    const { isSimulatingUser } = useSelector((state) => state.auth);
    const { field } = useController({ control, name: 'password' });
    const dispatch = useDispatch();

    const onSubmit = async (data) => {
        try {
            const response = await dispatch(
                authActions.simulateUser({
                    new_user_id: user_id,
                    password: data.password,
                })
            );
            window.open(
                `${basePath.USER_HOST}/login?simulate_token=${response.token}`,
                "_blank",
                "noopener,noreferrer"
            );
            onClose();
        } catch (e) {
            console.log(e);
            Notification.alert("Failed to simulate user", STATUS_TYPES.ERROR);
        }
    };
    return (
        <Form noValidate loading={isSimulatingUser}>
            <Form.Input label="Enter your password" required type="password" placeholder="Password" value={field.value} onChange={(_, { value }) => field.onChange({ target: { name: field.name, value } })} />
            <Button disabled={isSimulatingUser || !isValid || !isDirty} type="submit" onClick={handleSubmit(onSubmit)} primary>Confirm</Button>
        </Form>
    );
};

export default SimulateUserForm;
